import { render } from "./GSThursdayB.vue?vue&type=template&id=04f762d0&scoped=true"
import script from "./GSThursdayB.vue?vue&type=script&scoped=true&lang=js"
export * from "./GSThursdayB.vue?vue&type=script&scoped=true&lang=js"

import "./GSThursdayB.vue?vue&type=style&index=0&id=04f762d0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f762d0"]])

export default __exports__